import { render, staticRenderFns } from "./TaxSimulate.vue?vue&type=template&id=03702ea8"
import script from "./TaxSimulate.vue?vue&type=script&lang=js"
export * from "./TaxSimulate.vue?vue&type=script&lang=js"
import style0 from "./TaxSimulate.vue?vue&type=style&index=0&id=03702ea8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports